import { createReducer } from 'redux-starter-kit';
import {
  fetchVideoOptionsPageData, fetchUpdateVideoOptions,
} from './videoOptionUiActions';
import { selectRequest } from '../../../domain/requests/RequestReducer';


/**
 * A selector that returns the state of the 'FETCH_VIDEO_OPTION_PAGE_DATA' action.
 * @param {object} state The redux state for the application.
 * @return An object representing the request state.
 * @example const videoOptionRequest = selectRequestedVideoOption(state);
 */
export const selectVideoOptionsPageDataRequest = (state) => {
  const requestId = state.via.ui.videoOptions.requestVideoOptionsPageDataId;
  if (!requestId) return null;
  return selectRequest(state, requestId);
};

const initialEditingState = {
  isEditing: false,
  validationMessages: ({
    title: '',
    messages: [],
    visible: false,
  }),
};

const videoOptionsInitialState = {
  editState: initialEditingState, // Is a video option being edited/created.
  requestVideoOptionsPageDataId: null, // Request id for loading video option page data.
  requestAppConfigPageDataId: null, // Request id for loading video option page data.
};

/**
 * A selector that returns the state of the 'FETCH_APP_CONFIG_PAGE_DATA' action.
 * @param {object} state The redux state for the application.
 * @return An object representing the request state.
 * @example const appConfigRequest = selectRequestedAppConfig(state);
 */
export const selectAppConfigPageDataRequest = (state) => {
  const requestId = state.via.ui.appConfig.requestAppConfigPageDataId;
  if (!requestId) return null;
  return selectRequest(state, requestId);
};

/**
 * A reducer for handling the UI state changes for the Video options Configuration screen.
 */
const videoOptionReducer = createReducer(videoOptionsInitialState, {
  // A new request has been made to update a Video options.
  [fetchUpdateVideoOptions]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      requestVideoOptionsPageDataId: action.payload,
    },
  }),

  // A new request has been made to load all the Video options page data
  [fetchVideoOptionsPageData]: (state, action) => ({
    ...state,
    requestVideoOptionsPageDataId: action.payload,
  }),

});

export default videoOptionReducer;
